
                import wasm from "../../dist/pkg/web/perspective-server.wasm";
                export default function() { 
                    return fetch(new URL(__PSP_INLINE_WASM__7873665105597023__(wasm), import.meta.url));
                };
            